@if (vfo1Enabled()) {
  <app-header>
    <bit-breadcrumbs slot="breadcrumbs">
      <bit-breadcrumb [route]="['/settings']" icon="bwi-cog">{{
        "settings" | i18n
      }}</bit-breadcrumb>
      <bit-breadcrumb [route]="[]" queryParamsHandling="preserve">{{
        "acceptSponsoredFamiliesPlan" | i18n
      }}</bit-breadcrumb>
    </bit-breadcrumbs>
  </app-header>
}
<div class="tw-container">
  @if (!vfo1Enabled()) {
    <h1 bitTypography="h1">{{ "sponsoredFamiliesOffer" | i18n }}</h1>
  }
  <div *ngIf="loading" class="tw-mt-5 tw-flex tw-justify-center">
    <i
      class="bwi bwi-spinner bwi-spin bwi-2x tw-text-muted"
      title="{{ 'loading' | i18n }}"
      aria-hidden="true"
    ></i>
    <span class="tw-sr-only">{{ "loading" | i18n }}</span>
  </div>
  <div *ngIf="!loading && badToken" class="tw-mt-5 tw-flex tw-justify-center">
    <span>{{ "badToken" | i18n }}</span>
  </div>
  <form [bitSubmit]="submit" [formGroup]="formGroup" *ngIf="!loading && !badToken">
    @if (vfo1Enabled()) {
      @if (sponsoringOrganizationName) {
        <p bitTypography="body1" class="tw-mb-6">
          {{ "acceptSponsoredFamiliesPlanHelp" | i18n: sponsoringOrganizationName }}
        </p>
      } @else {
        <p bitTypography="body1" class="tw-mb-6">
          {{ "acceptSponsoredFamiliesPlanHelpNoOrg" | i18n }}
        </p>
      }
    } @else {
      <p bitTypography="body1">{{ "acceptBitwardenFamiliesHelp" | i18n }}</p>
    }
    <bit-form-field class="tw-w-1/2">
      <bit-label>{{ "sponsoredFamiliesSelectOffer" | vfo1I18n: "selectAFamilyVault" }}</bit-label>
      @if (vfo1Enabled()) {
        <bit-select formControlName="selectedFamilyOrganizationId" [placeholder]="'select' | i18n">
          @for (o of existingFamilyOrganizations$ | async; track o.id) {
            <bit-option [label]="o.name" [value]="o.id" icon="bwi-business"></bit-option>
          }
          <bit-option
            value="createNew"
            label="{{ 'createVault' | i18n }}"
            icon="bwi-plus"
          ></bit-option>
        </bit-select>
      } @else {
        <bit-select formControlName="selectedFamilyOrganizationId">
          <bit-option value="" label="-- {{ 'select' | i18n }} --" disabled></bit-option>
          <bit-option value="createNew" label="{{ 'newFamiliesOrganization' | i18n }}"></bit-option>
          <bit-option
            *ngFor="let o of existingFamilyOrganizations$ | async"
            [label]="o.name"
            [value]="o.id"
          >
          </bit-option>
        </bit-select>
      }
    </bit-form-field>
    <div *ngIf="showNewOrganization">
      <app-organization-plans
        [initialPlan]="familyPlan"
        [initialProductTier]="familyProductTier"
        [acceptingSponsorship]="true"
        [planSponsorshipType]="planSponsorshipType"
        (onSuccess)="onOrganizationCreateSuccess($event)"
      ></app-organization-plans>
    </div>
    <div class="tw-w-1/2" [class.tw-pt-2]="vfo1Enabled()" *ngIf="!showNewOrganization">
      <button bitButton buttonType="primary" bitFormButton type="submit">
        {{ "acceptOffer" | vfo1I18n: "applySponsorship" }}
      </button>
    </div>
  </form>
</div>
